import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import '.cl{font-weight:700;}.ssr-plugin'
import '.b0{margin-top:0px;}.ssr-plugin'
import '.dt{margin-bottom:1.5rem;}.ssr-plugin'
import useMediaQuery from '@app/util/useMediaQuery'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

export interface QuoteProps extends PropsWithChildren {
  style?: Style
}

export const Quote = ({ children, style }: QuoteProps) => {
  const isMobile = useMediaQuery()

  return (
    <styled.blockquote className="a4 cl b0 dt"
      style={{
        fontSize: isMobile ? '2rem' : '3rem',
        lineHeight: isMobile ? '130%' : '100%',
        ...style,
      }}
    >
      “{children}”
    </styled.blockquote>
  )
}
